import React, { Component } from 'react'
import { pianoKeys } from './piano-keys'
import Display from './display'
import Dial from './dial'
import { getSocket } from '../../services/sockets'

const waveforms = ['sine', 'square', 'triangle', 'sawtooth']

const styles = {
  dials: {
    margin: '0 auto',
    justifyContent: 'space-around',
    width: '25%',
  },
}
export default class WebAudio extends Component {
  constructor(props) {
    super(props)
    this.FFT_SIZE = Math.pow(2, 13)
    const selectedKeyIndex = pianoKeys.findIndex(({ frequency }) => frequency === 440)
    const selectedKey = pianoKeys[selectedKeyIndex]

    this._createAudioComponents()
    this.initialKeyIndex = selectedKeyIndex
    this.displayRef = React.createRef()

    this.state = {
      oscillatorType: waveforms[0],
      selectedKeyIndex,
      selectedKey,
      detune: 0,
    }
  }

  componentDidMount() {
    this.socket = getSocket()
    this.socket.on('detune', this._handleDetuneChange)
    this.socket.on('wavetype', wavetype => this._handleWaveTypeChange(waveforms.indexOf(wavetype)))
  }

  _chainAudio = (...nodes) => nodes.reduce((source, destination) => source.connect(destination))

  _createAudioComponents = () => {
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.analyserNode = this.audioContext.createAnalyser()
    this.analyserNode.fftSize = this.FFT_SIZE

    const bufferLength = this.analyserNode.frequencyBinCount
    this.audioDataArray = new Uint8Array(bufferLength)

    this.merger = this.audioContext.createChannelMerger(3)

    this.gainNode = this.audioContext.createGain()
    this.gainNode.gain.setValueAtTime(0.85, this.audioContext.currentTime)
  }

  _calculateDetune = index => (index - this.initialKeyIndex) * 100

  _findClosestKeyIndex = value => {
    const index = pianoKeys.findIndex(({ frequency }) => value <= frequency)
    const higher = pianoKeys[index]
    const lower = pianoKeys[index - 1]
    if (!lower) return index
    const distanceToHigher = Math.abs(higher.frequency - value)
    const distanceToLower = Math.abs(lower.frequency - value)

    if (distanceToHigher > distanceToLower) {
      return index - 1
    }
    return index
  }

  _draw = () => {
    this.analyserNode.getByteTimeDomainData(this.audioDataArray)
    this.displayRef.current.draw(this.audioDataArray)
    this.redrawID = requestAnimationFrame(this._draw)
  }

  _start = () => {
    this.audioContext.resume()
    this.oscillatorNode = this.audioContext.createOscillator()
    this.oscillatorNode.type = this.state.oscillatorType
    this.oscillatorNode.detune.setValueAtTime(this.state.detune, this.audioContext.currentTime)
    this.oscillatorNode.start()
    this._chainAudio(this.oscillatorNode, this.gainNode, this.analyserNode, this.audioContext.destination)
    this._draw()
  }

  _stop = () => {
    this.oscillatorNode.stop()
    this.audioContext.suspend()
    cancelAnimationFrame(this.redrawID)
  }

  _handleDetuneChange = detune => {
    if (this.oscillatorNode) {
      this.oscillatorNode.detune.setValueAtTime(detune, this.audioContext.currentTime)
    }
    this.setState({ detune })
  }

  _handleWaveTypeChange = index => {
    const type = waveforms[index]
    if (this.oscillatorNode) {
      this.oscillatorNode.type = type
    }
    this.setState({ oscillatorType: type })
  }

  render() {
    return (
      <div>
        <div>
          <Display ref={this.displayRef} />
        </div>
        <div>
          <button id="start" onClick={this._start}>
            start
          </button>
          <button id="stop" onClick={this._stop}>
            stop
          </button>
        </div>
        <div className="flex-row" style={styles.dials}>
          <Dial
            title="detune"
            sensitivity={0.1}
            min={-4800}
            max={3900}
            initialValue={0}
            step={10}
            onChange={this._handleDetuneChange}
          />
          <Dial
            title={this.state.oscillatorType}
            sensitivity={1}
            min={0}
            max={3}
            initialValue={0}
            step={1}
            onChange={this._handleWaveTypeChange}
            snap // IMPLEMENT THIS
          />
        </div>
      </div>
    )
  }
}
